var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmailEditor',{ref:"emailEditor",staticStyle:{"height":"600px"},attrs:{"options":{
      specialLinks: [
        {
          name: 'Website',
          href: _vm.siteUrl,
          target: '_self',
        },
        {
          name: 'Unsubscribe',
          href: _vm.siteUrl + '/unsubscribe',
          target: '_self',
        } ]
  }},on:{"load":_vm.editorLoaded}}),_c('b-button',{on:{"click":_vm.saveDesign}},[_vm._v("\n    Save\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }